import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { useTheme } from '@mui/material/styles';
import TextField, {
  FilledTextFieldProps,
  OutlinedTextFieldProps,
  StandardTextFieldProps,
  TextFieldProps,
} from '@mui/material/TextField';
import React from 'react';
import ETOIconButton, { ETOIconButtonProps } from '../Button/ETOIconButton';
import { useCommonClasses } from './DateTimeCommonStyles';

interface SelectorTextFieldProps
  extends Omit<StandardTextFieldProps, 'InputProps' | 'variant' | 'onClick'>,
  Omit<FilledTextFieldProps, 'InputProps' | 'variant' | 'onClick'>,
  Omit<OutlinedTextFieldProps, 'InputProps' | 'variant' | 'onClick'> {
  InputProps?: TextFieldProps['InputProps'];
  iconButtonProps?: Omit<ETOIconButtonProps, 'onclick'>;
  // eslint-disable-next-line no-unused-vars
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  open?: boolean;
}

const SelectorTextField = (props: SelectorTextFieldProps) => {
  const {
    iconButtonProps, onClick, open, InputProps, disabled, ...rest
  } = props;
  const theme = useTheme();
  const commonStyles = useCommonClasses(theme);

  return (
    <TextField
      {...rest}
      disabled={disabled}
      color="primary"
      variant="standard"
      onClick={() => onClick?.()}
      sx={[
        commonStyles.textField,
      ]}
      InputProps={{
        ...InputProps,
        disableUnderline: true,
        sx: commonStyles.textField,
        endAdornment: (
          <ETOIconButton
            {...iconButtonProps}
            color={iconButtonProps?.color || 'primary'}
            // onClick={onClick}
            size={iconButtonProps?.size || 'small'}
            disabled={disabled}
          >
            {
              (open) ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon />
            }
          </ETOIconButton>
        ),
      }}
    />
  );
};

export default SelectorTextField;
